import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    HDI_WARN: {
        id: 'warnings.hdi.',
        defaultMessage: 'HDI Warning'
    },
    BVM_VIN_NOT_FOUND: {
        id: 'warnings.bvm.vin.notFound',
        defaultMessage: 'The given VIN was not found in BVM'
    },
});

export default messages;
